import React, { Component } from 'react'; 
import { Link } from 'react-router-dom';

export default class Navbar extends Component {
    
 render() {
    
    return (
            
   <div> 
  
  <nav class="navbar navbar-icon-top navbar-expand-lg navbar-dark bg-dark">
  
   <a class="navbar-brand" href="/">TrueMen Khaftan </a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto">
    </ul>

    <ul class="navbar-nav ">
      <li class="nav-item">
       <li class="nav-item active">
        <Link class="nav-link"  to="/admin/Products">  
         <i class="fa fa-home"></i>
            Designs
          <span class="sr-only">(current)</span></Link>
       </li>
      </li>

      <li class="nav-item active">
        <Link class="nav-link" exact to="/admin/addProducts"> <i class="fa fa-tasks"></i>
            Manage Designs
        </Link>

      </li> 

      <li class="nav-item active">
       
        <Link class="nav-link" exact to="/admin/Orders">
           <i class="fa fa-address-book"></i>
            My Orders
          <span class="sr-only">(current)</span>
        </Link>
         
      </li>
    </ul>

    <form class="form-inline my-2 my-lg-0">
      <input class="form-control mr-sm-2" type="text" placeholder="Search" aria-label="Search" />
      <button class="btn btn-outline-success my-2 my-sm-0" type="submit">Search</button>
    </form>
  </div>
</nav>




   </div> 

   ); 

   }
}
